import React from "react";
import { createPortal } from "react-dom";
import { CloseIcon } from "../../../../helper/HwIcon";

export const HotelCheckoutPopup = ({ title, onClose, children }) => {
  return createPortal(
    <>
      <div
        className="hw-modal hw-modal--hotelDetails
   fade show
  "
      >
        <div className="hw-modal-dialog hw-modal-dialog-centered hw-modal-dialog-scrollable">
          <div className="hw-modal-content">
            <div className="hw-modal-header">
              <div className="hw-modal-hotelHeaderTitle">
                <div className="d-flex hw-gapy10 align-items-center">
                  <h3 className="hw-modal-headerTitle h3">{title}</h3>
                </div>
              </div>
              <button className="hw-modal--close" onClick={() => onClose()}>
                <CloseIcon />
              </button>
            </div>
            <div className="hw-modal-body">
                {children}
            </div>
          </div>
        </div>
      </div>
      <div className="hw-modal-backdrop fade show" />
    </>,
    document.body
  );
};
